import React, { useEffect } from "react";
import { notification } from "antd";
import { AlertType, useAlert } from "../provider/AlertProvider";

type NotificationType = "success" | "info" | "warning" | "error";

const MessageType: Record<string, string> = {
    "Unauthorized token": "인증 토큰이 오류입니다.",
    "Invalid password": "비밀번호가 틀립니다.",
    "Withdrawn user": "존재하지 않는 회원입니다.",
    "Account locked": "계정이 잠겨 있습니다.",
    "Access is denied": "해당 데이터에 대한 접근권한이 없습니다.",
    "Invalid data": "입력한 값이 오류입니다.",
    "Invalid email": "해당 이메일 정보가 없습니다.",
    "Invalid phone": "해당 전화번호 정보가 없습니다.",
    "Invalid name": "해당 이름 정보가 없습니다.",
    "Email already exists": "중복된 이메일입니다.",
    "Phone already exists": "중복된 전화번호입니다.",
    "Can't update email within 30 days": "이메일 수정 후 30일이 지나지 않았습니다.",
    "Invalid application name": "해당 어플리케이션 정보가 없습니다.",
    "Application name already exists": "중복된 어플리케이션 이름입니다.",
    "Invalid category id": "해당 카테고리 정보가 없습니다.",
    "Category name already exists": "중복된 카테고리 이름입니다.",
    "Invalid model id": "해당 모델 정보가 없습니다.",
    "Model name already exists": "중복된 모델 이름입니다.",
    "Invalid type id": "해당 타입 정보가 없습니다.",
    "Type name already exists": "중복된 타입 이름입니다.",
    "Invalid color id": "해당 색상 정보가 없습니다.",
    "Color name already exists": "중복된 색상 이름입니다.",
    "Invalid option id": "해당 옵션 정보가 없습니다.",
    "Option name already exists": "중복된 옵션 이름입니다.",
    "Invalid order id": "해당 주문 정보가 없습니다.",
    "Invalid preorder id": "해당 사전예약 정보가 없습니다.",
    "Preorder already exists": "중복된 사전예약 정보입니다.",
    "Invalid preorder event id": "사전예약이벤트 정보가 없습니다.",
    "Preorder event already exists": "중복된 사전예약이벤트 정보입니다.",
    "Selected preorder is not enough": "사전예약이벤트 당첨자가 부족합니다.",
    "Invalid question no": "해당 질문 정보가 없습니다.",
    "Question no already exists": "중복된 질문 정보입니다.",
    "Rent has been already started": "이미 출차된 차량입니다. 출차 취소 후 차량 변경을 진행해 주세요.",
    "Rent date already paid": "이미 예약된 날짜입니다.",
    "Invalid promotion code": "프로모션 코드가 올바르지 않습니다.",
    "Rent peak season already exists": "성수기 기간이 겹칩니다.",
    "Coupon is being used on user coupons": "할당된 쿠폰이 있어 삭제 할 수 없습니다.",
    "Coupon cannot be deleted due to being used by system": "B2B 쿠폰은 삭제 할 수 없습니다.",
};

function AlertPopup() {
    const { type, title, message, setAlert } = useAlert();
    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        let description = "";
        switch (type) {
            case AlertType.NONE:
                break;

            case AlertType.SUCCESS:
                openNotificationWithIcon("success", title, message);
                break;

            case AlertType.UNAUTHORIZED:
            case AlertType.INACCCESSIBLE_DATA:
            case AlertType.INVALID_PARAM:
            case AlertType.NONEXISTENT_USER:
            case AlertType.ALREADY_EXISTENT_USER:
            case AlertType.CANNOT_UPDATE_USER:
            case AlertType.NONEXISTENT_APPLICATION:
            case AlertType.ALREADY_EXISTENT_APPLICATION:
            case AlertType.NONEXISTENT_CATEGORY:
            case AlertType.ALREADY_EXISTENT_CATEGORY:
            case AlertType.NONEXISTENT_MODEL:
            case AlertType.ALREADY_EXISTENT_MODEL:
            case AlertType.NONEXISTENT_TYPE:
            case AlertType.ALREADY_EXISTENT_TYPE:
            case AlertType.NONEXISTENT_COLOR:
            case AlertType.ALREADY_EXISTENT_COLOR:
            case AlertType.NONEXISTENT_OPTION:
            case AlertType.ALREADY_EXISTENT_OPTION:
            case AlertType.NONEXISTENT_ORDER:
            case AlertType.NONEXISTENT_PREORDER:
            case AlertType.ALREADY_EXISTENT_PREORDER:
            case AlertType.NONEXISTENT_PREORDER_EVENT:
            case AlertType.ALREADY_EXISTENT_PREORDER_EVENT:
            case AlertType.NOT_ENOUGH_SELECTED_PREORDER:
            case AlertType.NONEXISTENT_QUESTION:
            case AlertType.ALREADY_EXISTENT_QUESTION:
            case AlertType.CANNOT_CHANGE_RENT_CAR:
            case AlertType.ALREADY_EXISTENT_RENT:
            case AlertType.NONEXISTENT_B2B:
            case AlertType.ALREADY_EXISTENT_RENT_PEAK_SEASON:
            case AlertType.COUPON_CANNOT_DELETE:
                description = MessageType[message];
                openNotificationWithIcon("error", title, description ? description : message);
                break;

            default:
                openNotificationWithIcon("error", title, message);
                break;
        }
    }, [type, message]);

    const openNotificationWithIcon = (type: NotificationType, title: string, message: string) => {
        api[type]({
            message: title,
            description: message,
            onClose: () => {
                setAlert(AlertType.NONE, "", "");
            },
            duration: 3,
            style: { top: 100 },
        });
    };
    return <>{contextHolder}</>;
}

export default AlertPopup;
